import { z } from "zod";

/**
 * The pool of tools the signed-in end-user is entitled to pick from. Each entry
 * is a bare, version-less tool ref (e.g. `"Github.CreateIssue"`), not a full
 * tool definition.
 */
export const entitlementsResponseSchema = z.object({
  tools: z.array(z.string()),
});

export type Entitlements = z.infer<typeof entitlementsResponseSchema>;

/**
 * Result of persisting the end-user's tool selection: the accepted refs plus the
 * slug of the personal gateway that now serves exactly those tools.
 */
export const setToolsResponseSchema = z.object({
  tools: z.array(z.string()),
  gateway_slug: z.string().min(1),
});

export type SetToolsResponse = z.infer<typeof setToolsResponseSchema>;

/**
 * The end-user's currently provisioned selection and gateway, used to rehydrate
 * the /eu page on reload. Unlike {@link setToolsResponseSchema}, `gateway_slug`
 * may be empty — the user may be entitled to tools but not yet have saved a
 * selection (no gateway provisioned).
 */
export const currentToolsResponseSchema = z.object({
  tools: z.array(z.string()),
  gateway_slug: z.string(),
});

export type CurrentTools = z.infer<typeof currentToolsResponseSchema>;
